// TODO: remove this file
// Bundle only required modules to resulting game.js

export * from './types';
export * from './installer';
export * from './utils';
export * from './events';
// fragments
export * from './fragments/display';
export * from './fragments/cli/BrowserConsoleInterface';
export * from './fragments/cli/CommandLineInterface';
export * from './fragments/geom/Rectangle';
export * from './fragments/locker/Lock';
export * from './fragments/locker/LockManager';
export * from './fragments/particlesV5/EmitterV5';
export * from './fragments/tween/Easing';
export * from './fragments/tween/Interpolation';
export * from './fragments/tween/MovieClipTween';
export * from './fragments/tween/Tween';
export * from './fragments/update/Meter';
export * from './fragments/update/Timer';
export * from './fragments/update/Updatable';
export * from './fragments/WebP/ParserWebP';
export * from './fragments/WebP/ResourceWebP';
export * from './fragments/ConsoleLogger';
export * from './fragments/DataStorage';
export * from './fragments/DebugStats';
export * from './fragments/DisplayObjectsPool';
export * from './fragments/EventManager';
export * from './fragments/LocalStorage';
export * from './fragments/PostMessageHandler';
export * from './fragments/URLParameters';
export * from './fragments/ScreenParameters';

export * from './services/eventManager/AsyncEventDecorator';
export * from './services/eventManager/EventManagerWithAsync';
export * from './services/eventManager/SlotEventAdapter';
export * from './services/resourceLoader/FileLoader';
export * from './services/resourceLoader/FontLoader';
export * from './services/resourceLoader/Loader';
export * from './services/resourceLoader/ResourceBuilderHandler';
export * from './services/resourceLoader/ResourceLoader';
export * from './services/resourceLoader/SpineCustomParser';
export * from './services/resourceLoader/SpriteParserGem';
export * from './services/resourceLoader/SpriteParserGem';
export * from './services/screenManager/ScreenManager';
export * from './services/screenManagerV2/ScreenManagerV2';
export * from './services/screenManager/types';
export * from './services/system/System';
export * from './services/system/Application';
export * from './services/Browser';
export * from './services/CommandLineInterfaceService';
export * from './services/Device';
export * from './services/DisplayObjectUtils';
export * from './services/FullscreenManager';
export * from './services/KeyboardModule';
export * from './services/LanguageService';
export * from './services/ObjectBuilder';
export * from './services/ResolutionManager';
export * from './services/Settings';
export * from './services/UpdateManager';
export * from './services/VisibilityManager';
export * from './services/SpineUtils';
export * from './services/CurrencyFormatter';
export * from './services/inputGestures';
export * from './fragments/store/Store';
export * from './services/StoreSetter';
export * from './services/EventsBridge';

export * from './configs';
export * from './Game';

